export const ProgressBar = ({ progress }: { progress: number }) => (
  <div className="bg-primary-100 z-[21] h-[4px] w-full overflow-hidden rounded-[19px]">
    <div
      className="h-full bg-gradient-to-r from-[#2196F3] to-[#CC41D3]"
      style={{
        width: `${progress}%`,
      }}
    />
  </div>
);
